import type { NextPage } from 'next';
import ProjectLayout from '@layouts/project-layout/project-layout';
import WallexProject from '@components/projects/wallex/wallex';
import { isProduction } from '@libs/environment';
import WallexLeadMagnet from '@components/leadmagnets/wallex';
import { ProjectProps } from '@models/project.interface';

// todo: remove this when no longer needed to be archived
// import LegacyWallexComponent from '@components/projects/wallex/wallex';

const Wallex: NextPage<ProjectProps> = (project) => {
  if (isProduction()) {
    return (
      <ProjectLayout project={project}>
        <WallexLeadMagnet />
      </ProjectLayout>
    );
  } else {
    return (
      <ProjectLayout project={project}>
        <WallexProject breadcrumbsText={project.project.breadcrumbsText} />
      </ProjectLayout>
    );
  }
};

export { getServerSideProps } from '@layouts/project-layout/project-layout';

export default Wallex;
